import React from "react";
import { Chevron } from "../common/Icons";
import LinkNoStyle from "../common/LinkNoStyle/LinkNoStyle";
import * as styles from "./PageNavigation.module.scss";

export interface PageNavigationOption {
	heading: "Previous" | "Next";
	title?: string;
	url?: string;
}
export interface PageNavigationProps {
	title?: string;
	previous?: PageNavigationOption;
	next?: PageNavigationOption;
}

export const PageNavigation: React.FC<PageNavigationProps> = ({
	title,
	previous,
	next,
}) => {
	if (!previous?.url?.length && !next?.url?.length) return null;
	const PageNavigationOption: React.FC<PageNavigationOption> = ({
		heading,
		title,
		url,
	}) => {
		if (!url?.length) return null;
		return (
			<LinkNoStyle className={styles.pagenavigationoption} to={url}>
				<div className={styles.navigation}>
					{heading === "Previous" && (
						<Chevron
							className={styles.iconleft}
							rotation={-90}
							height={"14px"}
							width={"14px"}
						/>
					)}
					<div>{heading}</div>
					{heading === "Next" && (
						<Chevron
							className={styles.iconright}
							rotation={90}
							height={"14px"}
							width={"14px"}
						/>
					)}
				</div>
				<div className={styles.title}>
					<div className={styles.titletext}>{title}</div>
				</div>
			</LinkNoStyle>
		);
	};

	return (
		<div className={styles.pagenavigationwrapper}>
			<div className={styles.pagenavsectionbreak} />
			{title && <h3>{title}</h3>}
			<div className={styles.navigationoptions}>
				{previous && <PageNavigationOption {...previous} />}
				{previous && next && <div className={styles.spacer} />}
				{next && <PageNavigationOption {...next} />}
			</div>
		</div>
	);
};

export default PageNavigation;
